import React from "react";
import PropTypes from "prop-types";
import { Modal } from "components/Modal";
import { ClientPagedTable } from "components/Table/ClientPagedTable";
import { CoinHandIcon } from "assets/icons";
import {
  HeaderContent,
  IconWrapper,
  HoldingsSection,
} from "features/Explore/v2/Components/AllHoldingsModal/AllHoldingsModal.styles";
import { Text } from "style/v2/components/Typography";
import { columns } from "./columns";

// Same frame as the Top Holdings "All holdings" modal, holding the full
// Allocations rows (30 Day / Average / Current) the card only previews.
const AllocationsModal = ({ isOpen, onClose, holdings }) => (
  <Modal
    show={isOpen}
    onHide={onClose}
    size="lg"
    heading={
      <HeaderContent>
        <IconWrapper>
          <img src={CoinHandIcon} alt="Holdings" width={24} height={24} />
        </IconWrapper>
        <div>
          <Text variant="sectionHeading" weight="500" as="h2" mb="0">
            Top Holdings Allocations
          </Text>
          <Text variant="body" color="tertiary">
            30 day, average and current weight of every asset
          </Text>
        </div>
      </HeaderContent>
    }
  >
    <HoldingsSection>
      <ClientPagedTable
        data={holdings}
        columns={columns}
        showEntriesText={false}
        notFoundText="No holdings data available"
      />
    </HoldingsSection>
  </Modal>
);

AllocationsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  holdings: PropTypes.array,
};

export default AllocationsModal;
